import React from 'react'

export const SortUpIcon = props => {
  return (
    <svg
      {...props}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.49947 18.9996L6.49947 5"
        stroke="#AEAFC7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 15.5957L6.5 19L3 15.5957"
        stroke="#AEAFC7"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.4995 5.00036L17.4995 19"
        stroke={props.disabled ? '#AEAFC7' : '#1D2943'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 8.4043L17.5 5.00002L14 8.4043"
        stroke={props.disabled ? '#AEAFC7' : '#1D2943'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
